export default __webpack_public_path__ + "static/media/slider-img4.5b9dd899.jpg";